module.exports = __webpack_public_path__ + "static/WIIBPhone4-4f8ee7de6995eb8c99a6a54bc9a93671.svg";